export class LoadReportsEvent {
    public static readonly type = '[JobsPlacements] Load reports event';
}
